import React from "react";
import { Box, MenuItem, Select, Typography } from "@mui/material";
import { useTheme } from "@mui/styles";
import { useIntl } from "react-intl";

export const SORT_OPTIONS = [
  { value: "newest", labelId: "recruiter.cv_theque.sort_newest", defaultLabel: "Newest" },
  { value: "last_active", labelId: "recruiter.cv_theque.sort_last_active", defaultLabel: "Last active" },
];

const CVThequeSortControl = ({ value, onChange }) => {
  const intl = useIntl();
  const theme = useTheme();

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <Typography
        variant="body2"
        sx={{ color: theme.palette.text.secondary, whiteSpace: "nowrap" }}
      >
        {intl.formatMessage({ id: "recruiter.cv_theque.sort_by", defaultMessage: "Sort by" })}
      </Typography>
      <Select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        size="small"
        variant="outlined"
        MenuProps={{
          disableScrollLock: true,
          PaperProps: { sx: { borderRadius: "16px", mt: 0.5 } },
        }}
        sx={{
          borderRadius: "20px",
          backgroundColor: theme.palette.common.white,
          fontFamily: "Segoe UI Semibold, system-ui, sans-serif",
          fontSize: "14px",
          "& .MuiSelect-select": {
            paddingTop: "8px",
            paddingBottom: "8px",
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: theme.palette.divider,
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: theme.palette.text.secondary,
          },
        }}
      >
        {SORT_OPTIONS.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {intl.formatMessage({ id: option.labelId, defaultMessage: option.defaultLabel })}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
};

export default CVThequeSortControl;
